import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { BaasActionButton } from '../../../../baas-action-button/baas-action-button';
import { BaasActionButtonOptions } from '../../../../baas-action-button/baas-action-button.types';

@Component({
    selector: 'baas-layout-menu-striking-actions',
    templateUrl: './baas-layout-menu-striking-actions.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasActionButton],
    host: { class: 'bar-layout-menu-striking-actions' }
})
export class BaasLayoutMenuStrikingActionsComponent {
    readonly items = input<BaasActionButtonOptions[]>(undefined);

    protected readonly effectiveItems = computed(() => {
        const transformActions = (actions: BaasActionButtonOptions[]) => {
            return actions.map((a) => {
                a.variant = 'outlined';
                return a;
            });
        };
        return this.items() ? transformActions(this.items()) : [];
    });
}
